export default "__VITE_ASSET__DxGN_DKF__"